import config from "../config/axiosConf"
import { BaseRequest } from 'utils.cryptos'

const encryptUtil = new BaseRequest(config.publicKey)

export default encryptUtil



// WEBPACK FOOTER //
// ./src/utils/gatewayEncrypt.js